import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/snapbox-landingpage/src/components/pages/copyright/index.tsx");
